import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddQuotation from "../../../component/AddQuotation";
import ViewImageModal from "../../../component/ViewImageModal";
import { RefurbSupportServicesDetailReducer } from "./RefurbSupportServicesSlice";

function RefurbSupportServicesRequests() {
  const [ReqId, setReqId] = useState("");
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [imgSRC, setimgSRC] = useState("");
  const [img, setimg] = useState({});
  const handleShow = () => {
    setShow(!show);
  };
  const { id } = useParams();
  const dispatch = useDispatch();

  const detail = useSelector((store) => store.RefurbSupportServices.details);
  //console.log(detail);

  const getdetail = useCallback(() => {
    dispatch(
      RefurbSupportServicesDetailReducer({
        id: id,
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    let isrander = false;
    if (!isrander) {
      getdetail();
    }

    return () => {
      isrander = false;
    };
  }, [getdetail]);
  return (
    <>
      <article className="col-lg-9">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <h2 className="head-title">Refurb Support</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 mt-4 text-center">
              <img
                src={
                  detail?.serviceDetails?.image || "assets/images/employe.png"
                }
                className="img-fluid srvsIcon"
                alt=""
              />
            </div>
            <div className="col-sm-12 mt-4">
              <h2>User Detail</h2>
            </div>

            <div className="col-sm-12 mb-4">
              <div className="view-detail mt-0">
                <div className="table-responsive pt-4">
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src="assets/images/Full-Name.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          First Name
                        </td>
                        <td>
                          <img
                            src="assets/images/Full-Name.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Last Name
                        </td>
                        <td>
                          <img
                            src="assets/images/mobile-nu.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Mobile Number{" "}
                        </td>
                        <td>
                          <img
                            src="assets/images/Email-Address.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          personal Email
                        </td>
                        <td>
                          <img
                            src="assets/images/Email-Address.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          official Email
                        </td>
                      </tr>
                      <tr>
                        <th>{detail?.userDetails?.first_name || "NA"}</th>
                        <th>{detail?.userDetails?.last_name || "NA"}</th>
                        <th>
                          {detail?.userDetails?.mobile
                            ? `${detail?.userDetails?.countryCode} ${detail?.userDetails?.mobile}`
                            : "NA"}
                        </th>
                        <th>{detail?.userDetails?.personal_email || "NA"}</th>
                        <th>{detail?.userDetails?.official_email || "NA"}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-sm-12 mb-4">
              <h2>Vehicle Detail</h2>
            </div>
            <div className="col-sm-12 mb-4">
              <div className="view-detail mt-0 pt-3">
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-lg-4 mb-2">
                    <div className="pl-3">
                      <img
                        src="assets/images/REGN-No-Initials.png"
                        className="detail-icon"
                        alt=""
                      />{" "}
                      <span>Vehicle Regn No</span>
                      <p>
                        <b>{detail?.vehicle_regn_no || "NA"}</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 mb-2">
                    <div className="pl-3">
                      <img
                        src="assets/images/OEM-Make.png"
                        className="detail-icon"
                        alt=""
                      />{" "}
                      <span>Make</span>
                      <p>
                        <b>{detail?.make || "NA"}</b>
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 mb-2">
                    <div className="pl-3">
                      <img
                        src="assets/images/Model.png"
                        className="detail-icon"
                        alt=""
                      />{" "}
                      <span>Modal</span>
                      <p>
                        <b>{detail?.model || "NA"}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 mb-4">
              <div className="view-detail pt-3 mt-0">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h2>Support Required for</h2>
                    <ul>
                      {detail?.refurbDetails?.support_required_for?.map(
                        (item, i) => (
                          <li key={i}>{item?.name}</li>
                        )
                      )}
                    </ul>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h2>RF Estimate</h2>
                    <p className="mb-1 pt-3">
                      {detail?.refurbDetails?.rf_type === "1"
                        ? "Speak with Expert"
                        : detail?.refurbDetails?.rf_type === "2"
                        ? "Raise the Home"
                        : detail?.refurbDetails?.rf_type === "3"
                        ? "Visit the Workshop"
                        : "NA"}
                    </p>

                    <img
                      src={
                        detail?.refurbDetails?.rf_type === "1"
                          ? detail?.refurbDetails?.rf_estimate_image
                          : ""
                      }
                      className={
                        detail?.refurbDetails?.rf_type === "1"
                          ? "img-fluid idImages"
                          : "d-none"
                      }
                      alt=""
                      onClick={() => {
                        setModalName("ViewImage");
                        setimgSRC("refurbDetails.rf_estimate_image");
                        handleShow();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="view-btns">
                {detail?.quotation_pdf === null ? (
                  <button
                    className="btn btn-reject btn-view mt-2"
                    onClick={() => {
                      setReqId(detail?.id);
                      setModalName("AddQuotation");
                      handleShow();
                    }}
                  >
                    Add Quotation
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {show && modalName === "AddQuotation" && (
          <AddQuotation
            show={show}
            handleShow={handleShow}
            ReqId={ReqId}
            getList={getdetail}
          />
        )}
        {detail[imgSRC.split(".")[0]] &&
          imgSRC &&
          modalName === "ViewImage" && (
            <ViewImageModal
              show={show}
              handleShow={handleShow}
              imgSRC={imgSRC}
              image={detail}
              setitem={setimg}
              setimgSRC={setimgSRC}
            />
          )}
      </article>
    </>
  );
}

export default RefurbSupportServicesRequests;
